var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardsactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boards_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12343",
    transform: "translate(17556 12054)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17511.7-12020.4h-17.4c-1.1,0-1.9-0.9-1.9-1.9v-29c0-1.1,0.9-1.9,1.9-1.9h17.4c1.1,0,1.9,0.9,1.9,1.9v29 C-17509.8-12021.2-17510.6-12020.4-17511.7-12020.4z M-17527.2-12024.2h13.5v-25.2h-13.5V-12024.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17517.5-12040.7h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17515.6-12041.5-17516.4-12040.7-17517.5-12040.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17517.5-12032.9h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17515.6-12033.8-17516.4-12032.9-17517.5-12032.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12344",
    transform: "translate(17556 12054)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308_00000046337654205983407680000002766554741190206356_",
    x: -17554.3,
    y: -12051.3,
    className: "st0",
    width: 17.4,
    height: 40.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17536.9-12008.7h-17.4c-1.1,0-1.9-0.9-1.9-1.9v-40.6c0-1.1,0.9-1.9,1.9-1.9h17.4c1.1,0,1.9,0.9,1.9,1.9 v40.6C-17534.9-12009.6-17535.8-12008.7-17536.9-12008.7z M-17552.4-12012.6h13.5v-36.8h-13.5V-12012.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-17542.7-12040.7h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17540.7-12041.5-17541.6-12040.7-17542.7-12040.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-17542.7-12032.9h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17540.7-12033.8-17541.6-12032.9-17542.7-12032.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-17542.7-12025.2h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17540.7-12026.1-17541.6-12025.2-17542.7-12025.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardsactive);
export default __webpack_public_path__ + "static/media/Boards active.77326f4422731502ad852a1b59533d77.svg";
export { ForwardRef as ReactComponent };